import { Box } from "Components/Base/Layout/Box";
import React from "react";

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <Box mt={3}>{children}</Box>
    </div>
  );
};
